import { RouteProp, useNavigation, useRoute } from "@react-navigation/core";
import { Box, Button, HStack, ScrollView, Text, VStack } from "native-base";
import React from "react";
import { infos } from "../../content/infos";

export function InfoPage() {
  const navigation = useNavigation();
  const route = useRoute<RouteProp<{ params: { infoId: number } }, "params">>();
  const { infoId } = route.params;
  const title = "Depois do Tratamento você tem acesso aos seguintes direitos";

  const handleClickMoreInfo = (infoId: number) => {
    navigation.navigate("SubInfoPage", { infoId });
  };

  const info = infos.find((info) => info.id === infoId);

  if (!info) {
    return (
      <Box flex={1} bgColor="white" p="8">
        <VStack space={8} w="100%">
          <Text
            fontSize="2xl"
            fontWeight="bold"
            textAlign="center"
            color="#f4545c"
          >
            Informação não encontrada 😢
          </Text>
        </VStack>
      </Box>
    );
  }

  return (
    <Box flex={1} bgColor="white" p="8">
      <VStack space={2} w="100%">
        <Text
          fontSize="2xl"
          fontWeight="bold"
          textAlign="center"
          color="#f4545c"
        >
          {info.title}
        </Text>

        <ScrollView w="100%" h="85%">
          <Text textAlign="justify">{info.description}</Text>

          <VStack space={4}>
            {
              //array with keys of moreInfos
              info.moreInfos &&
                Object.keys(info.moreInfos).map((key, index) => (
                  <Button
                    key={index}
                    flex={1}
                    onPress={() => {
                      if (info.moreInfos)
                        handleClickMoreInfo(info.moreInfos[key]);
                    }}
                  >
                    {key}
                  </Button>
                ))
            }
          </VStack>
        </ScrollView>
      </VStack>
    </Box>
  );
}
